module.exports = __webpack_public_path__ + "static/media/format-image-outline--gray.e5ea60bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/format-image-outline--gray.svg
// module id = 804
// module chunks = 0